import React from "react";
import { useTranslation } from 'react-i18next';

const ADOWorkItemsList = props => {
  const { items, deleteItem } = props;
  const { t } = useTranslation() 
  if (!items.length) return <div className="font14">{t('Nothing selected.')}</div>;

  return items.map(item => (
    <div key={item.id} className="ado-workitem-list-item">
      <span className="ado-workitem-list-item-details">
        <b>{item.id}</b>
        {` | ${item.name}`}
      </span>
      <span
        className="icon icon-outline-close-24px pointer"
        onClick={() => deleteItem(item)}
      ></span>
    </div>
  ));
};

export default ADOWorkItemsList;
